import React, { useCallback, useEffect, useState } from 'react';
import { Button, Col, DatePicker, Dropdown, Form, Input, Row, Select, Tooltip } from 'antd';
import ActionsComponent from 'src/components/shared/ActionsComponent';
import GridLayout from 'src/components/shared/gridLayout';
import { handleOnKeyDown } from 'src/utils/service';
const Filters = (props) => {
    const { RangePicker } = DatePicker;
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm()
    useEffect(() => {
        form.setFieldsValue(props?.filterValues);
        if (props?.onloadGrid) {
            props.onloadGrid();
        }
    }, [props?.filterValues])

    const handleSearch = useCallback((values) => {
        const trimmedValues = {
            ...values,
            cardNumber: values?.cardNumber?.trim(),
            email: values?.email?.trim()
        };
        props?.filterObj(trimmedValues);
        setOpen(false)
    }, [])

    const handleOpenChange = useCallback((nextOpen, info) => {
        if (info.source === 'trigger' || nextOpen) {
            setOpen(nextOpen);
        }
    }, [])
    const handleMenuClick = (e) => {
        if (e.key === '3') {
            setOpen(false);
        }
    };
    const clearRecords = useCallback(() => {
        let obj = { "email": null, 'cardNumber': null, "currency": null, "tradeType": null, "Status": null, "startDate": null, "endDate": null };
        props?.filterObj(obj);
        form.resetFields()
    }, [form, props])

    const emailChangeHandler = useCallback((e) => {
        const trimmedValue = e.target.value.replace(/\s+/g, '');
        form.setFieldsValue({ email: trimmedValue });
    }, [])
    
    const items = [
        {
            label:
                <Form className="grid-filter-form"
                    autoComplete="off"
                    onFinish={handleSearch}
                    form={form}>
                    <p className='filter-option-title'>Filter Options</p>
                    <Row gutter={[16]} className='filters-row'>
                        <Col sm={24} md={24} lg={24} xl={24} xxl={24}>
                            <Form.Item
                                className=''
                                label="Email"
                                name="email"
                                rules={[
                                    {
                                        validator(_, emailValue) {
                                            const emailRegex = /^[\w\+-]+(?:\.[\w\+-]+)*@(?:[\w-]+\.)*\w[\w-]{0,66}\.[a-z]{2,200}(?:\.[a-z]{2})?$/;
                                            if (emailValue && !emailRegex.test(emailValue)) {
                                                return Promise.reject('Invalid email');
                                            } else {
                                                return Promise.resolve();
                                            }
                                        }
                                    },
                                ]}
                            >
                                <Input placeholder='Enter email' onChange={emailChangeHandler} onKeyDown={handleOnKeyDown} />
                            </Form.Item></Col>
                        <Col sm={24} md={24} lg={24} xl={24} xxl={24}>
                            <Form.Item
                                className=''
                                label="Card Number"
                                name="cardNumber"
                                rules={[
                                    {
                                        validator(_, cardNumber) {
                                            if (Number(cardNumber) || !cardNumber) {
                                                return Promise.resolve();
                                            } else if (!Number(cardNumber)) {
                                                return Promise.reject("Only numbers allowed");
                                            }
                                        }
                                    },
                                ]}
                            >
                                <Input placeholder='Enter card number' maxLength={16} onKeyDown={handleOnKeyDown}/>
                            </Form.Item>
                        </Col>
                        <Col sm={24} md={24} lg={24} xl={24} xxl={24}>
                            <Form.Item
                                name="currency"
                                label="Tx Wallet"
                            >
                                <Select
                                    className="Currency"
                                    placeholder={`Select Tx Wallet`}
                                    tabIndex={2}
                                >
                                    {props?.currencies?.map((item) => (
                                        <Option value={item?.name} key={item?.name}>{item?.name}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col sm={24} md={24} lg={24} xl={24} xxl={24}>
                            <Form.Item
                                name="tradeType"
                                label="Tx Type"
                            >
                                <Select
                                    className=""
                                    placeholder={`Select Tx Type`}
                                >
                                    {props?.tradeLu?.map((item) => (
                                        <Option value={item?.name} key={item?.name}>{item?.name}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col sm={24} md={24} lg={24} xl={24} xxl={24}>
                            <Form.Item
                                name="Status"
                                label="Status"
                            >
                                <Select
                                    className=""
                                    placeholder={`Select Status`}
                                >
                                    {props?.stateLu?.map((item) => (
                                        <Option value={item?.name} key={item?.name}>{item?.name}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col sm={24} md={24} lg={24} xl={24} xxl={24}>
                            <Form.Item name="dateRange" label="Date" >
                                <RangePicker format="DD-MM-YYYY" /></Form.Item>
                        </Col>
                    </Row>
                    <div className='mt-2 md:flex justify-end gap-2 space-y-2 md:space-y-0'>
                        <Button className='cancel-btn' onClick={clearRecords} key="back">Clear</Button>
                        <Button className='primary-btn' type="primary" htmlType="submit">Search</Button>
                    </div>
                </Form>
            ,
            key: '1',
        },
    ];

    const onActionClick = useCallback((key) => {
        handleToolBarActions(key)
    }, [])

    const handleToolBarActions = useCallback((action) => {
        if (action === 'exportexcel') {
            props?.handleExcelExport();
        }
    }, [props])

    return (
        <div className='flex gap-2 justify-end items-center mt-3'>
            <ActionsComponent serviceName={"CardsManageService.ActivityLogs"} onActionClick={onActionClick} />
            <Dropdown
                overlayClassName='filterdropdown-overlay'
                className='filter-dropdown'
                menu={{
                    items,
                    onClick: handleMenuClick,
                }}
                onOpenChange={handleOpenChange}
                open={open}
                autoFocus={true}
                trigger={'click'}
            >
                <a onClick={(e) => e.preventDefault()} className='flex'>
                    <Tooltip title='Filter'>   <span className='icon filter-icon-dropdown'></span></Tooltip>
                </a>
            </Dropdown>
            <GridLayout />
        </div>
    );
}
export default Filters;
